/* tslint:disable */
/* eslint-disable */
/**
 * API Explorer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Result } from '../models';
// @ts-ignore
import { ResultOfCompanyThemeDto } from '../models';
// @ts-ignore
import { ResultOfListOfChangeLogDto } from '../models';
// @ts-ignore
import { ResultOfString } from '../models';
/**
 * SystemConfigApi - axios parameter creator
 * @export
 */
export const SystemConfigApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [applicationVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemConfigChangeLogs: async (applicationVersion?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1.1/SystemConfig/ChangeLogs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (applicationVersion !== undefined) {
                localVarQueryParameter['ApplicationVersion'] = applicationVersion;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemConfigReleasedVersion: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1.1/SystemConfig/ReleasedVersion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemConfigThemeGET: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1.1/SystemConfig/Theme`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [xRequestid] 
         * @param {string} [website] 
         * @param {string} [primaryColor] 
         * @param {string} [secondaryColor] 
         * @param {File} [logo] 
         * @param {File} [frontImage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemConfigThemePUT: async (xRequestid?: string, website?: string, primaryColor?: string, secondaryColor?: string, logo?: File, frontImage?: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1.1/SystemConfig/Theme`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (xRequestid != null) {
                localVarHeaderParameter['x-requestid'] = String(xRequestid);
            }


                if (website !== undefined) { 
                localVarFormParams.append('Website', website as any);
            }
    
                if (primaryColor !== undefined) { 
                localVarFormParams.append('PrimaryColor', primaryColor as any);
            }
    
                if (secondaryColor !== undefined) { 
                localVarFormParams.append('SecondaryColor', secondaryColor as any);
            }
    
                if (logo !== undefined) { 
                localVarFormParams.append('Logo', logo as any);
            }
    
                if (frontImage !== undefined) { 
                localVarFormParams.append('FrontImage', frontImage as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SystemConfigApi - functional programming interface
 * @export
 */
export const SystemConfigApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SystemConfigApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [applicationVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async systemConfigChangeLogs(applicationVersion?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultOfListOfChangeLogDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.systemConfigChangeLogs(applicationVersion, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async systemConfigReleasedVersion(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultOfString>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.systemConfigReleasedVersion(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async systemConfigThemeGET(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultOfCompanyThemeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.systemConfigThemeGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [xRequestid] 
         * @param {string} [website] 
         * @param {string} [primaryColor] 
         * @param {string} [secondaryColor] 
         * @param {File} [logo] 
         * @param {File} [frontImage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async systemConfigThemePUT(xRequestid?: string, website?: string, primaryColor?: string, secondaryColor?: string, logo?: File, frontImage?: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Result>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.systemConfigThemePUT(xRequestid, website, primaryColor, secondaryColor, logo, frontImage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SystemConfigApi - factory interface
 * @export
 */
export const SystemConfigApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SystemConfigApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [applicationVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemConfigChangeLogs(applicationVersion?: string, options?: any): AxiosPromise<ResultOfListOfChangeLogDto> {
            return localVarFp.systemConfigChangeLogs(applicationVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemConfigReleasedVersion(options?: any): AxiosPromise<ResultOfString> {
            return localVarFp.systemConfigReleasedVersion(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemConfigThemeGET(options?: any): AxiosPromise<ResultOfCompanyThemeDto> {
            return localVarFp.systemConfigThemeGET(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [xRequestid] 
         * @param {string} [website] 
         * @param {string} [primaryColor] 
         * @param {string} [secondaryColor] 
         * @param {File} [logo] 
         * @param {File} [frontImage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemConfigThemePUT(xRequestid?: string, website?: string, primaryColor?: string, secondaryColor?: string, logo?: File, frontImage?: File, options?: any): AxiosPromise<Result> {
            return localVarFp.systemConfigThemePUT(xRequestid, website, primaryColor, secondaryColor, logo, frontImage, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SystemConfigApi - object-oriented interface
 * @export
 * @class SystemConfigApi
 * @extends {BaseAPI}
 */
export class SystemConfigApi extends BaseAPI {
    /**
     * 
     * @param {string} [applicationVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemConfigApi
     */
    public systemConfigChangeLogs(applicationVersion?: string, options?: AxiosRequestConfig) {
        return SystemConfigApiFp(this.configuration).systemConfigChangeLogs(applicationVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemConfigApi
     */
    public systemConfigReleasedVersion(options?: AxiosRequestConfig) {
        return SystemConfigApiFp(this.configuration).systemConfigReleasedVersion(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemConfigApi
     */
    public systemConfigThemeGET(options?: AxiosRequestConfig) {
        return SystemConfigApiFp(this.configuration).systemConfigThemeGET(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [xRequestid] 
     * @param {string} [website] 
     * @param {string} [primaryColor] 
     * @param {string} [secondaryColor] 
     * @param {File} [logo] 
     * @param {File} [frontImage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemConfigApi
     */
    public systemConfigThemePUT(xRequestid?: string, website?: string, primaryColor?: string, secondaryColor?: string, logo?: File, frontImage?: File, options?: AxiosRequestConfig) {
        return SystemConfigApiFp(this.configuration).systemConfigThemePUT(xRequestid, website, primaryColor, secondaryColor, logo, frontImage, options).then((request) => request(this.axios, this.basePath));
    }
}
